import { render, staticRenderFns } from "./BindAuditKPI.vue?vue&type=template&id=01248e4c&scoped=true&"
import script from "./BindAuditKPI.vue?vue&type=script&lang=js&"
export * from "./BindAuditKPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01248e4c",
  null
  
)

export default component.exports